import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/regenerator";
import checkContainMedia from '@anm/helpers/checkContainMedia';
import getAuthHeaders from '@anm/helpers/getAuthHeaders';
import { getManifest } from '@anm/hosting-player';
import { useEffect, useRef, useState } from 'react';
var initialCheckerState = {
  isMediaReady: false,
  videoManifest: null
};
var DELAY = 1000;

var useVideoStatusChecker = function useVideoStatusChecker(_ref) {
  var hostId = _ref.hostId,
      _ref$source = _ref.source,
      source = _ref$source === void 0 ? 'cdn' : _ref$source,
      progress = _ref.progress,
      _ref$mediaType = _ref.mediaType,
      mediaType = _ref$mediaType === void 0 ? 'video' : _ref$mediaType,
      _ref$canCleanState = _ref.canCleanState,
      canCleanState = _ref$canCleanState === void 0 ? false : _ref$canCleanState,
      uploadCheckerUrl = _ref.uploadCheckerUrl,
      supportedExtensions = _ref.supportedExtensions;

  var _useState = useState(initialCheckerState),
      media = _useState[0],
      setMedia = _useState[1];

  var timer = useRef();
  useEffect(function () {
    if (progress !== 100 || media.isMediaReady) return;

    var checkManifestStatus = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var manifest, containMedia;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getManifest({
                  source: source,
                  hostId: hostId
                });

              case 2:
                manifest = _context.sent;
                containMedia = checkContainMedia({
                  supportedExtensions: supportedExtensions,
                  type: mediaType,
                  list: manifest.main
                });

                if (containMedia) {
                  setMedia({
                    isMediaReady: true,
                    videoManifest: manifest
                  });
                } else {
                  timer.current = global.setTimeout(checkManifestStatus, DELAY);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function checkManifestStatus() {
        return _ref2.apply(this, arguments);
      };
    }();

    var checkUploadStatus = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _mediaUploadResponse$;

        var mediaUpload, mediaUploadResponse, files, isStable;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch(uploadCheckerUrl, getAuthHeaders());

              case 2:
                mediaUpload = _context2.sent;
                _context2.next = 5;
                return mediaUpload.json();

              case 5:
                mediaUploadResponse = _context2.sent;
                files = (_mediaUploadResponse$ = mediaUploadResponse.files) === null || _mediaUploadResponse$ === void 0 ? void 0 : _mediaUploadResponse$.filter(function (item) {
                  return item.file.fileType === mediaType;
                });
                isStable = files === null || files === void 0 ? void 0 : files.some(function (media) {
                  return media.file.status === 'stable';
                });

                if (isStable) {
                  setMedia(_objectSpread(_objectSpread({}, media), {}, {
                    isMediaReady: true
                  }));
                } else {
                  timer.current = global.setTimeout(checkUploadStatus, DELAY);
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function checkUploadStatus() {
        return _ref3.apply(this, arguments);
      };
    }();

    (uploadCheckerUrl ? checkUploadStatus : checkManifestStatus)();
    return function () {
      return clearTimeout(timer.current);
    };
  }, [progress, media.isMediaReady]);
  useEffect(function () {
    if (media.isMediaReady) {
      clearTimeout(timer.current);
    }
  }, [media.isMediaReady]);
  useEffect(function () {
    canCleanState && setMedia(initialCheckerState);
  }, [canCleanState]);
  return media;
};

export default useVideoStatusChecker;